import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import '../styles/markdown.css';

interface MarkdownRendererProps {
  content: string;
  className?: string;
  forceLightMode?: boolean; // 添加强制使用浅色模式的选项
}

const MarkdownRenderer: React.FC<MarkdownRendererProps> = ({ 
  content, 
  className = '',
  forceLightMode = false
}) => {
  // 检测当前系统主题
  const [isDarkMode, setIsDarkMode] = useState(false);
  
  useEffect(() => {
    // 检测系统主题
    const darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    setIsDarkMode(darkModeMediaQuery.matches);
    
    // 监听主题变化
    const handleThemeChange = (e: MediaQueryListEvent) => {
      setIsDarkMode(e.matches);
    };
    
    darkModeMediaQuery.addEventListener('change', handleThemeChange);
    
    return () => {
      darkModeMediaQuery.removeEventListener('change', handleThemeChange);
    };
  }, []);
  
  // 根据主题和强制浅色模式选项设置样式
  const themeStyles = forceLightMode ? {
    // 强制浅色模式样式
    color: '#24292e',
    backgroundColor: '#ffffff'
  } : {};
  
  // 为表格添加特殊样式
  const additionalStyles = `
    ${forceLightMode ? `
      .markdown-body table {
        color: #24292e !important;
      }
      .markdown-body table th,
      .markdown-body table td {
        background-color: #ffffff !important;
        border-color: #dfe2e5 !important;
      }
      .markdown-body table tr {
        background-color: #ffffff !important;
      }
      .markdown-body table tr:nth-child(2n) {
        background-color: #f6f8fa !important;
      }
      .markdown-body table th {
        background-color: #f6f8fa !important;
      }
    ` : ''}
  `;
  
  return (
    <>
      {forceLightMode && <style>{additionalStyles}</style>}
      <div 
        className={`markdown-body ${className} ${forceLightMode ? 'force-light-mode' : ''}`} 
        style={themeStyles}
      >
        <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
      </div>
    </>
  );
};

export default MarkdownRenderer;
